/* Beaumont homepage behaviour: scroll reveal, counters, colour switcher, accordion.
   Everything degrades to a readable static page if JS never runs, so nothing here is
   load-bearing for content - only for motion and interaction. */
(function () {
  'use strict';

  // Each section tags the asset in, so the file can arrive more than once. Bind only the first.
  if (window.__beaumontHome) return;
  window.__beaumontHome = true;

  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- reveal on scroll ------------------------------------------------ */
  function reveal() {
    var items = document.querySelectorAll('.bm-rise:not(.is-in)');
    if (!items.length) return;
    if (calm || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---- count up -------------------------------------------------------- */
  function counters() {
    var nums = document.querySelectorAll('[data-count]');
    if (!nums.length) return;

    function run(el) {
      var target = parseFloat(el.getAttribute('data-count'));
      var suffix = el.getAttribute('data-suffix') || '';
      var dur = 1100, t0 = null;
      if (calm) { el.textContent = target + suffix; return; }
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    if (!('IntersectionObserver' in window)) { nums.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        run(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.6 });
    nums.forEach(function (el) { io.observe(el); });
  }

  /* ---- colour switcher ------------------------------------------------- */
  function switcher() {
    document.querySelectorAll('[data-bm-switch]').forEach(function (root) {
      if (root.dataset.bmBound) return;          // safe to call more than once
      root.dataset.bmBound = '1';
      var buttons = root.querySelectorAll('.bm-sw__btn');
      var shots = root.querySelectorAll('.bm-sw__stage img');
      var label = root.querySelector('[data-bm-switch-name]');

      function pick(name) {
        buttons.forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.dataset.colour === name));
        });
        shots.forEach(function (img) {
          img.classList.toggle('is-on', img.dataset.colour === name);
        });
        if (label) label.textContent = name;
        // the line that belongs to this colourway comes up, the others step back
        root.querySelectorAll('[data-bm-switch-notes] .bmc-note__l').forEach(function (n) {
          n.classList.toggle('is-on', n.dataset.colour === name);
        });
      }

      var opts = root.querySelector('.bm-sw__opts');
      buttons.forEach(function (b) {
        b.addEventListener('click', function () {
          pick(b.dataset.colour);
          // the pulse has done its job the moment someone presses one
          if (opts) opts.classList.add('is-touched');
        });
      });
      if (buttons.length) pick(buttons[0].dataset.colour);
    });
  }

  /* ---- accordion ------------------------------------------------------- */
  function accordion() {
    document.querySelectorAll('.bm-q').forEach(function (q) {
      var btn = q.querySelector('.bm-q__btn');
      var panel = q.querySelector('.bm-q__panel');
      var inner = q.querySelector('.bm-q__inner');
      if (!btn || !panel || !inner) return;

      btn.setAttribute('aria-expanded', 'false');

      btn.addEventListener('click', function () {
        var open = q.classList.contains('is-open');
        // one at a time, the way the reference page behaves
        var group = q.closest('[data-bm-accordion]') || document;
        group.querySelectorAll('.bm-q.is-open').forEach(function (other) {
          if (other === q) return;
          other.classList.remove('is-open');
          other.querySelector('.bm-q__panel').style.height = '0px';
          other.querySelector('.bm-q__btn').setAttribute('aria-expanded', 'false');
        });

        q.classList.toggle('is-open', !open);
        btn.setAttribute('aria-expanded', String(!open));
        panel.style.height = open ? '0px' : inner.offsetHeight + 'px';
      });
    });

    // keep an open panel correct when the viewport reflows the text
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        document.querySelectorAll('.bm-q.is-open').forEach(function (q) {
          q.querySelector('.bm-q__panel').style.height =
            q.querySelector('.bm-q__inner').offsetHeight + 'px';
        });
      }, 120);
    });
  }

  /* ---- marquee: duplicate the group so the loop has no seam ------------- */
  function marquee() {
    document.querySelectorAll('.bm-marquee__track').forEach(function (track) {
      if (track.children.length !== 1) return;
      track.appendChild(track.firstElementChild.cloneNode(true));
    });

    // The sheen repaints text, so it only runs while the strip is actually on screen.
    document.querySelectorAll('.bm-marquee--light:not([data-mq-init])').forEach(function (el) {
      el.setAttribute('data-mq-init', '1');
      if (calm || !('IntersectionObserver' in window)) { el.classList.add('is-live'); return; }
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { el.classList.toggle('is-live', e.isIntersecting); });
      }, { threshold: 0.01 }).observe(el);
    });
  }

  // The colour section tags its images from an inline script, then calls this in case the
  // section was re-rendered by the theme editor after the initial bind.
  window.__beaumontHomeSwitchers = switcher;

  /* ---- review coverflow ------------------------------------------------ */
  function testimonials() {
    document.querySelectorAll('[data-bmr]:not([data-bmr-init])').forEach(function (root) {
      root.setAttribute('data-bmr-init', '1');

      var rail = root.querySelector('[data-bmr-viewport]');
      var items = [].slice.call(root.querySelectorAll('[data-bmr-item]'));
      var dots = root.querySelector('[data-bmr-dots]');
      var prev = root.querySelector('[data-bmr-prev]');
      var next = root.querySelector('[data-bmr-next]');
      if (!rail || !items.length) return;

      // Phones get a pager, not the coverflow (owner 2026-10-09: "choppy… the lines around the
      // image disappear… skip multiple in one swipe and end mid testimonial"). Desktop below is
      // untouched.
      if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
        pager(root, rail, items, dots, prev, next);
        return;
      }

      var current = 0;

      // Layout is measured once, not per frame. Reading getBoundingClientRect for every card on
      // every scroll frame forces fifteen synchronous layouts, which is what made this stutter.
      // offsetLeft only lines up with scrollLeft when the rail is the offsetParent, so that is
      // verified rather than assumed.
      var geom = [], span = 1;
      function measureOnce() {
        var gap = parseFloat(getComputedStyle(rail).gap) || 0;
        var direct = items.length > 0 && items[0].offsetParent === rail;
        var base = direct ? 0 : rail.getBoundingClientRect().left - rail.scrollLeft;
        geom = items.map(function (el) {
          var left = direct ? el.offsetLeft : el.getBoundingClientRect().left - base;
          var print = el.querySelector('.bmr-print');
          return { c: left + el.offsetWidth / 2, w: el.offsetWidth,
                   h: print ? print.offsetHeight : 0 };
        });
        span = ((geom[0] ? geom[0].w : 0) + gap) * 1.6 || 1;
      }
      measureOnce();

      // height is set in the rail's own box model: border-box counts the padding, content-box
      // does not, and guessing wrong shows up as a band of exactly padding-top + padding-bottom
      function fitHeight() {
        var g = geom[current];
        if (!g || !g.h) return;
        var cs = getComputedStyle(rail);
        var pad = cs.boxSizing === 'border-box'
          ? parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom) : 0;
        rail.style.setProperty('--bmr-h', (g.h + pad) + 'px');
      }
      fitHeight();

      // --k is 1 when a card sits on the rail's midpoint and falls to 0 one card away. Scale
      // and fade read from it; nothing that triggers layout does.
      var ticking = false;
      function paint() {
        if (!geom.length || !geom[0].w) measureOnce();
        var mid = rail.scrollLeft + rail.clientWidth / 2;
        var best = 0, bestD = Infinity;
        for (var i = 0; i < items.length; i++) {
          var d = Math.abs(geom[i].c - mid);
          var k = d > span ? 0 : 1 - d / span;
          items[i].style.setProperty('--k', k.toFixed(3));
          if (d < bestD) { bestD = d; best = i; }
        }
        if (best !== current) {
          current = best;
          fitHeight();
          if (dots) [].slice.call(dots.children).forEach(function (d, n) {
            d.setAttribute('aria-selected', String(n === current));
          });
        }
        if (prev) prev.disabled = current === 0;
        if (next) next.disabled = current === items.length - 1;
        ticking = false;
      }
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(paint);
      }

      // Smooth scrolling keeps moving after the last scroll event fires, so a single paint
      // leaves --k describing where the cards were rather than where they stopped. Keep
      // painting until scrollLeft has actually settled.
      var settleRaf = null;
      function settle() {
        var last = -1, still = 0;
        cancelAnimationFrame(settleRaf);
        (function frame() {
          paint();
          if (Math.abs(rail.scrollLeft - last) < 0.5) { still++; } else { still = 0; }
          last = rail.scrollLeft;
          if (still < 4) settleRaf = requestAnimationFrame(frame);
        })();
      }

      function goTo(i, user) {
        i = Math.max(0, Math.min(items.length - 1, i));
        var el = items[i];
        rail.scrollTo({
          left: el.offsetLeft - (rail.clientWidth - el.offsetWidth) / 2,
          behavior: calm ? 'auto' : 'smooth'
        });
        if (user) hold();
        settle();
      }

      if (dots) {
        dots.innerHTML = '';
        items.forEach(function (_, n) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'bmr-dot';
          d.setAttribute('role', 'tab');
          d.setAttribute('aria-label', 'Review ' + (n + 1));
          d.addEventListener('click', function () { goTo(n, true); });
          dots.appendChild(d);
        });
      }
      if (prev) prev.addEventListener('click', function () { goTo(current - 1, true); });
      if (next) next.addEventListener('click', function () { goTo(current + 1, true); });

      rail.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { measureOnce(); fitHeight(); paint(); goTo(current); });

      // auto-advance, wrapping; held back while the visitor is interacting or the rail is off-screen
      var speed = (parseFloat(root.getAttribute('data-speed')) || 6) * 1000;
      var paused = true, timer = null, holdT = null;
      function hold() {
        paused = true;
        clearTimeout(holdT);
        holdT = setTimeout(function () { paused = false; }, speed * 2);
      }
      function play() {
        if (calm || timer) return;
        timer = setInterval(function () {
          if (paused) return;
          goTo(current >= items.length - 1 ? 0 : current + 1);
        }, speed);
      }
      ['mouseenter', 'touchstart', 'focusin'].forEach(function (e) {
        rail.addEventListener(e, function () { paused = true; }, { passive: true });
      });
      ['mouseleave', 'focusout'].forEach(function (e) {
        rail.addEventListener(e, function () { paused = false; });
      });
      rail.addEventListener('touchend', hold, { passive: true });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            paused = !e.isIntersecting;
            if (e.isIntersecting) play();
          });
        }, { threshold: 0.25 }).observe(root);
      } else { paused = false; play(); }

      paint();
      goTo(Math.floor(items.length / 2));
      settle();
    });
  }

  /* ---- review pager (phones) ---------------------------------------------
     One swipe = one review, always. The cards sit on a flex track moved with one GPU transform;
     the finger drags it, release decides +1 / 0 / -1 (never more), and the track glides to
     that card's centre. No native momentum scroll to fling past cards, no per-frame scaling to
     stutter or blur the hairline, and the address bar showing/hiding (a height-only resize) no
     longer re-centres mid-swipe. */
  function pager(root, rail, items, dots, prev, next) {
    root.classList.add('is-pager');
    var track = root.querySelector('[data-bmr-track]');
    var cur = 0;
    function target(i) { var el = items[i]; return (rail.clientWidth - el.offsetWidth) / 2 - el.offsetLeft; }
    function setX(v) { track.style.transform = 'translate3d(' + v + 'px,0,0)'; }
    function fit() {
      var p = items[cur].querySelector('.bmr-print'); if (!p) return;
      var cs = getComputedStyle(rail);
      var pad = cs.boxSizing === 'border-box' ? parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom) : 0;
      rail.style.setProperty('--bmr-h', (p.offsetHeight + pad) + 'px');
    }
    function go(i) {
      cur = Math.max(0, Math.min(items.length - 1, i));
      track.classList.remove('is-drag');
      setX(target(cur));
      items.forEach(function (el, n) { el.classList.toggle('is-on', n === cur); });
      if (dots) [].slice.call(dots.children).forEach(function (d, n) { d.setAttribute('aria-selected', String(n === cur)); });
      if (prev) prev.disabled = cur === 0;
      if (next) next.disabled = cur === items.length - 1;
      fit();
    }
    if (dots) {
      dots.innerHTML = '';
      items.forEach(function (_, n) {
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'bmr-dot'; d.setAttribute('role', 'tab');
        d.setAttribute('aria-label', 'Review ' + (n + 1));
        d.addEventListener('click', function () { go(n); hold(); });
        dots.appendChild(d);
      });
    }
    if (prev) prev.addEventListener('click', function () { go(cur - 1); hold(); });
    if (next) next.addEventListener('click', function () { go(cur + 1); hold(); });

    var sx = 0, sy = 0, st = 0, dx = 0, axis = null;
    rail.addEventListener('touchstart', function (e) {
      var t = e.touches[0]; sx = t.clientX; sy = t.clientY; st = Date.now(); dx = 0; axis = null; paused = true;
    }, { passive: true });
    rail.addEventListener('touchmove', function (e) {
      var t = e.touches[0], mx = t.clientX - sx, my = t.clientY - sy;
      if (!axis) {
        if (Math.abs(mx) < 6 && Math.abs(my) < 6) return;
        axis = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
        if (axis === 'x') track.classList.add('is-drag');
      }
      if (axis !== 'x') return;
      e.preventDefault();
      dx = mx;
      var edge = (cur === 0 && dx > 0) || (cur === items.length - 1 && dx < 0);
      setX(target(cur) + (edge ? dx * 0.3 : dx));
    }, { passive: false });
    function end() {
      if (axis === 'x') {
        var v = Math.abs(dx) / Math.max(1, Date.now() - st);
        var step = (Math.abs(dx) > rail.clientWidth * 0.18 || (v > 0.35 && Math.abs(dx) > 24)) ? (dx < 0 ? 1 : -1) : 0;
        go(cur + step);
      }
      axis = null; hold();
    }
    rail.addEventListener('touchend', end, { passive: true });
    rail.addEventListener('touchcancel', function () { axis = null; go(cur); hold(); }, { passive: true });

    var lastW = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW) return;            // address bar: height only, ignore
      lastW = window.innerWidth;
      track.classList.add('is-drag'); go(cur); track.classList.add('is-drag');
      requestAnimationFrame(function () { track.classList.remove('is-drag'); });
    });
    window.addEventListener('load', fit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);

    var speed = (parseFloat(root.getAttribute('data-speed')) || 6) * 1000;
    var paused = true, holdT = null;
    function hold() { paused = true; clearTimeout(holdT); holdT = setTimeout(function () { paused = false; }, speed * 2); }
    if (!calm) setInterval(function () { if (!paused) go(cur >= items.length - 1 ? 0 : cur + 1); }, speed);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (!holdT || !e.isIntersecting) paused = !e.isIntersecting; });
      }, { threshold: 0.25 }).observe(root);
    }

    track.classList.add('is-drag'); go(0);
    requestAnimationFrame(function () { track.classList.remove('is-drag'); });
  }

  /* ---- guarantee: fire the one-shot sequence once, then stop watching ---- */
  function guarantee() {
    document.querySelectorAll('[data-bmg]:not([data-bmg-init]), [data-bmp]:not([data-bmg-init])').forEach(function (el) {
      el.setAttribute('data-bmg-init', '1');
      if (calm || !('IntersectionObserver' in window)) { el.classList.add('is-in'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          io.disconnect();            // nothing here needs watching after it has played
        });
      // threshold is a fraction of the ELEMENT, so a section taller than the viewport can
      // never reach 0.25 while its top is on screen. Fire on any meaningful intersection.
      }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });
      io.observe(el);
    });
  }

  /* ---- FAQ: accordion plus a rail that only runs while it is on screen ---- */
  function faq() {
    document.querySelectorAll('[data-bmf]:not([data-bmf-init])').forEach(function (root) {
      root.setAttribute('data-bmf-init', '1');

      /* ---- photo notes: Vencé's scroll-scrubbed entrance, ported verbatim ----
         The perceived quality is in the DOUBLE filter, not the CSS: an exponential lerp
         toward the target at 0.06 a frame, and THEN easeInOutCubic on the smoothed value.
         Drop either and it reads as a cheap parallax.

         --q is the note's own progress, remapped from the last 30% of --p, so the note is
         already sliding out before the photograph is home. Both are written per frame; the
         loop parks itself the moment nothing is moving. */
      var notes = [].slice.call(root.querySelectorAll('[data-bmfn]'))
        .map(function (el) { return { el: el, target: 0, cur: 0 }; });
      if (notes.length) {
        var write = function (c) {
          var p = c.cur;
          p = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
          c.el.style.setProperty('--p', p.toFixed(3));
          var q = Math.max(0, Math.min(1, (p - 0.70) / 0.30));
          c.el.style.setProperty('--q', q.toFixed(3));
        };
        if (calm) {
          notes.forEach(function (c) {
            c.el.style.setProperty('--p', '1');
            c.el.style.setProperty('--q', '1');
          });
        } else {
          var nRaf = null;
          var nCompute = function () {
            var vh = window.innerHeight;
            // 2026-10-17 (owner): every photograph is home by the time the whole FAQ is on
            // screen. They used to settle at 46% of the viewport, which the lower prints never
            // reached while the FAQ was fully visible, so they were still flying in.
            var stack = root.querySelector('.bmfn-stack') || root;
            var sb = stack.getBoundingClientRect();
            var whole = sb.top < vh * 0.9 && sb.bottom <= vh + 80;
            notes.forEach(function (c, i) {
              var r = c.el.getBoundingClientRect();
              var mid = r.top + r.height / 2;
              var enter = vh * 1.05, settle = vh * 0.78;
              var p = (enter - mid) / (enter - settle);
              p = Math.max(0, Math.min(1, p));
              var stag = i * 0.04;
              c.target = whole ? 1 : Math.max(0, Math.min(1, (p - stag) / (1 - stag)));
            });
          };
          var nTick = function () {
            var moving = false;
            notes.forEach(function (c) {
              c.cur += (c.target - c.cur) * 0.06;
              if (Math.abs(c.target - c.cur) > 0.0015) moving = true; else c.cur = c.target;
              write(c);
            });
            nRaf = moving ? requestAnimationFrame(nTick) : null;
          };
          var nKick = function () { nCompute(); if (!nRaf) nRaf = requestAnimationFrame(nTick); };
          addEventListener('scroll', nKick, { passive: true });
          addEventListener('resize', nKick);
          nCompute();
          notes.forEach(function (c) { c.cur = c.target; write(c); });
          addEventListener('load', nKick);
          setTimeout(nKick, 300);
        }
      }

      var rail = root.querySelector('[data-bmf-rail]');
      var track = root.querySelector('[data-bmf-track]');
      var bar = root.querySelector('.bmf-rail__bar i');

      if (rail && track) {
        var perSet = function () {
          var set = root.querySelector('.bmf-rail__set');
          return set ? Math.max(1, set.children.length) : 1;
        };
        // The set is rendered twice, so wrapping the scroll position at the halfway mark makes
        // the loop endless in both directions with nothing visible happening.
        var half = function () { return track.scrollWidth / 2; };
        var wrap = function () {
          var h = half();
          if (h < 10) return;
          if (rail.scrollLeft >= h) rail.scrollLeft -= h;
          else if (rail.scrollLeft < 1) rail.scrollLeft += h;
        };
        var barTick = function () {
          if (!bar) return;
          var h = half();
          if (h < 10) return;
          bar.style.width = Math.max(8, 100 / perSet()) + '%';
          bar.style.left = ((rail.scrollLeft % h) / h * 100) + '%';
        };

        // The cards are one column wide, measured from the rail. A CSS percentage cannot do
        // this: it would resolve against the track, and the track is sized by the cards.
        var sizeCards = function () {
          // floor, and measure the border box: clientWidth was rounding up and leaving the
          // card 13px wider than its frame, so every card sat slightly clipped
          var w = Math.floor(rail.getBoundingClientRect().width);
          if (w > 0) rail.style.setProperty('--bmf-cardw', w + 'px');
        };
        sizeCards();
        requestAnimationFrame(sizeCards);
        addEventListener('load', sizeCards);
        addEventListener('resize', sizeCards, { passive: true });

        var ticking = false;
        rail.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () { wrap(); barTick(); ticking = false; });
        }, { passive: true });

        // start slightly in, so scrolling up straight away has somewhere to go
        requestAnimationFrame(function () { rail.scrollLeft = half() * 0.02; barTick(); });

        // Auto-advance a card at a time, and stand down the moment the visitor takes over.
        var paused = false, holdT = null, timer = null;
        // declared here because the arrow handlers are bound before it is assigned
        var restart = function () {};
        var hold = function () {
          paused = true;
          clearTimeout(holdT);
          holdT = setTimeout(function () { paused = false; }, 5000);
        };
        ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(function (ev) {
          rail.addEventListener(ev, hold, { passive: true });
        });
        // A trackpad reports deltaX on a horizontal strip; a mouse wheel only ever reports
        // deltaY. Without this the rail cannot be wheeled at all on a desktop mouse.
        rail.addEventListener('wheel', function (e) {
          if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
          e.preventDefault();
          rail.scrollLeft += e.deltaY;
        }, { passive: false });
        rail.addEventListener('mouseenter', function () { paused = true; });
        rail.addEventListener('mouseleave', hold);

        var step = function () {
          if (paused || calm) return;
          var card = root.querySelector('.bmf-card');
          if (!card) return;
          var gap = parseFloat(getComputedStyle(track).gap) || 0;
          rail.scrollBy({ left: card.offsetWidth + gap, behavior: 'smooth' });
        };

        // The arrows drive the same scrollBy the auto-advance uses, and call hold() so the
        // timer stands down for five seconds — otherwise a click and the timer would fight
        // over scrollTop and the rail would stutter.
        var nudge = function (dir) {
          var card = root.querySelector('.bmf-card');
          if (!card) return;
          hold();
          var gap = parseFloat(getComputedStyle(track).gap) || 0;
          rail.scrollBy({ left: dir * (card.offsetWidth + gap), behavior: 'smooth' });
        };
        var prev = root.querySelector('[data-bmf-prev]');
        var next = root.querySelector('[data-bmf-next]');
        if (prev) prev.addEventListener('click', function () { nudge(-1); restart(); });
        if (next) next.addEventListener('click', function () { nudge(1); restart(); });

        // How long a card stays is measured from the card, not fixed. The fifteen reviews run
        // 19 to 43 words: at 200 wpm that is 5.7s to 12.9s of reading, so the old flat 4.2s
        // interval moved the shortest one on before it could be finished and the longest one
        // before it was half read. Each card now gets its own reading time plus a few seconds
        // to look at the photograph and to start reading the next.
        var WPS = 200 / 60;
        var visibleCard = function () {
          var cards = root.querySelectorAll('.bmf-card');
          if (!cards.length) return null;
          var w = cards[0].offsetWidth + (parseFloat(getComputedStyle(track).gap) || 0);
          if (w < 10) return cards[0];
          return cards[Math.round(rail.scrollLeft / w) % cards.length] || cards[0];
        };
        var dwell = function () {
          var card = visibleCard();
          if (!card) return 9000;
          var words = (card.textContent || '').trim().split(/\s+/).length;
          var ms = (words / WPS + 3.5) * 1000;
          return Math.min(17000, Math.max(8000, ms));   // 8s floor, 17s ceiling
        };
        var tick = function () {
          if (!paused && !calm) step();
          timer = setTimeout(tick, dwell());
        };
        var start = function () { if (!timer) timer = setTimeout(tick, dwell()); };
        restart = function () { if (timer) { clearTimeout(timer); timer = null; } start(); };
        var stop = function () { if (timer) { clearTimeout(timer); timer = null; } };

        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (es) {
            es.forEach(function (e) { e.isIntersecting ? start() : stop(); });
          }, { threshold: 0.05 }).observe(root);
        } else { start(); }
      }

      root.querySelectorAll('.bmf-item').forEach(function (item) {
        var btn = item.querySelector('.bmf-q');
        var panel = item.querySelector('.bmf-a');
        var inner = item.querySelector('.bmf-a__in');
        if (!btn || !panel || !inner) return;

        btn.addEventListener('click', function () {
          var open = item.classList.contains('is-open');
          // 2026-10-21 (owner: "the FAQ is shaky when opening stuff on mobile"). Measured: with an
          // answer open ABOVE the tapped question, its 0.6s collapse pulled the tapped row up 261px
          // under the finger. An open row above now closes in the same frame and the page scrolls
          // by exactly what it lost, so the tapped question stays put; rows below still animate.
          var y0 = btn.getBoundingClientRect().top, above = false;
          root.querySelectorAll('.bmf-item.is-open').forEach(function (other) {
            if (other === item) return;
            var op = other.querySelector('.bmf-a');
            if (other.compareDocumentPosition(item) & Node.DOCUMENT_POSITION_FOLLOWING) {
              above = true;
              op.style.transition = 'none';
              requestAnimationFrame(function () { requestAnimationFrame(function () { op.style.transition = ''; }); });
            }
            other.classList.remove('is-open');
            op.style.height = '0px';
            other.querySelector('.bmf-q').setAttribute('aria-expanded', 'false');
          });
          if (above) {
            var dy = btn.getBoundingClientRect().top - y0;
            if (dy) window.scrollTo({ top: window.scrollY + dy, behavior: 'instant' });   // the theme sets smooth scrolling
          }
          item.classList.toggle('is-open', !open);
          btn.setAttribute('aria-expanded', String(!open));
          panel.style.height = open ? '0px' : inner.offsetHeight + 'px';
        });
      });

      var t;
      window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          root.querySelectorAll('.bmf-item.is-open').forEach(function (i) {
            i.querySelector('.bmf-a').style.height = i.querySelector('.bmf-a__in').offsetHeight + 'px';
          });
        }, 120);
      });
    });
  }

  function init() { marquee(); reveal(); counters(); switcher(); accordion(); testimonials(); guarantee(); faq(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
